import _ from "lodash";

// tslint:disable-next-line:no-namespace
declare global {

    interface String {
        format(this: string, ...args: any[]): string;
        isEmail(this: string): boolean;
        isImgExtension(this: string): boolean;
        replaceAll(this: string, search: string | RegExp, replace: string): string;
        splitOnLastInstanceOf(this: string, splitter: string): string[];
        getAllAfterLastInstanceOf(this: string, splitter: string): string;
        getStringAfterLastIndexOf(this: string, splitter: string): string;
        toUpperCaseFirstLetter(this: string): string;
        toLowerCaseFirstLetter(this: string): string;
        contains(this: string, it: string): boolean;
        startsWith(this: string, searchString: string, position: number): boolean;
    }

}

var str = String.prototype;

str.format = function (this: string, ...args: any[]): string {
    var me = this.toString();
    for (var i = 0; i < args.length; i++) {
        me = me.replaceAll("{" + i + "}", args[i] || "");
    }
    return me;
};

str.isEmail = function (this: string): boolean {
    var regex = /^[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?$/;
    return regex.test(this);
};

str.isImgExtension = function (this: string): boolean {
    switch (this.toString().toLowerCase()) {
        case "jpg":
        case "png":
        case "gif":
            return true;
        default:
            return false;
    }
};

str.replaceAll = function (this: string, search: string, replace: string): string {
    return this.split(search).join(replace);
};

str.splitOnLastInstanceOf = function (this: string, splitter: string): string[] {
    var array = [this];
    var index = this.lastIndexOf(splitter);

    if (index != -1) {
        var begin = this.substring(0, index);
        var end = this.substring(index + splitter.length);
        array = [begin, end];
    }

    return array;
};

str.getAllAfterLastInstanceOf = function (this: string, splitter: string): string {
    return this.splitOnLastInstanceOf(splitter)[1] || this;
};

str.getStringAfterLastIndexOf = function (this: string, splitter: string): string {
    var lastIndex = this.lastIndexOf(splitter);
    var newString = this.substr(lastIndex + 1);

    return newString;
};

str.toUpperCaseFirstLetter = function (this: string): string {
    return this.charAt(0).toUpperCase() + this.slice(1);
};

str.toLowerCaseFirstLetter = function (this: string): string {
    return this.charAt(0).toLowerCase() + this.slice(1);
};

str.contains = function (this: string, it: string): boolean {
    return this.indexOf(it) != -1;
};

str.startsWith = str.startsWith || function (this: string, searchString: string, position: number): boolean {
    return _.startsWith(this, searchString, position);
};
